// Autogenerated file
export const bidPaymentStatusesEnum = {
    NotPaid: "NotPaid",
    Paid: "Paid",
    PartiallyPaid: "PartiallyPaid",
};
export const bidPaymentStatuses = [
    { label: "Не оплачен", value: "NotPaid" },
    { label: "Оплачен", value: "Paid" },
    { label: "Частичная оплата", value: "PartiallyPaid" },
];
